import React from 'react';
import HeaderTwo from "../components/HeaderTwo";
import Plans from "../components/Refine/Plans";
import FooterTwo from "../components/FooterTwo";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";

function SellerPlan() {
  return (
    <div>
        {/* ColorInit */}
        <ColorInit color={true} />

        {/* ScrollToTop */}
        <ScrollToTop smooth color="#FA6400" />

        {/* Preloader */}

        {/* HeaderOne */}
        <HeaderTwo category={true} />

        {/* Plans */}
        <Plans />
        
        {/* FooterTwo */}
        <FooterTwo />
    </div>
  )
}

export default SellerPlan
